import { render, staticRenderFns } from "./FormulateObjectMedical.vue?vue&type=template&id=04e9f3a8&"
import script from "./FormulateObjectMedical.vue?vue&type=script&lang=ts&"
export * from "./FormulateObjectMedical.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports